export const pushNotificationKeys = {
  all: (tenantCode) => ["push-notifications", tenantCode],
  capabilities: (tenantCode) => [
    ...pushNotificationKeys.all(tenantCode),
    "capabilities",
  ],
  jobsRoot: (tenantCode) => [
    ...pushNotificationKeys.all(tenantCode),
    "jobs",
  ],
  jobs: (tenantCode, filters) => [
    ...pushNotificationKeys.jobsRoot(tenantCode),
    filters,
  ],
  job: (tenantCode, jobId) => [
    ...pushNotificationKeys.jobsRoot(tenantCode),
    "detail",
    `${jobId}`,
  ],
  preview: (tenantCode, request) => [
    ...pushNotificationKeys.all(tenantCode),
    "preview",
    request,
  ],
  imagesRoot: (tenantCode) => [
    ...pushNotificationKeys.all(tenantCode),
    "images",
  ],
  images: (tenantCode, page, pageSize) => [
    ...pushNotificationKeys.imagesRoot(tenantCode),
    page,
    pageSize,
  ],
  installations: (tenantCode, filters) => [
    ...pushNotificationKeys.all(tenantCode),
    "installations",
    filters,
  ],
  users: (tenantCode, search, page, pageSize) => [
    ...pushNotificationKeys.all(tenantCode),
    "users",
    search,
    page,
    pageSize,
  ],
};
